import { createDataSelectors } from "@app/modules/app.reducers";
import { IssueTrackingToolRule } from "@ea/shared_types/types";

export const itsRulesDataSelectors = createDataSelectors<IssueTrackingToolRule>()("itsRules");
